import styled, { css } from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: stretch;
  @media (max-width: 768px){
    flex-direction: column;
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(231deg, #ECECEC, #FFFFFF, #F5F5F5);;
  z-index: 1;
  padding:0 73px 0 73px;
  overflow-y: auto;
  padding-bottom: 20px;
  @media (max-width: 768px){
    padding: 30px;
    background-image: none;
    background-color: white;
    margin-top: -15px;
    padding-bottom: 53px;
    border-radius: 15px 15px 0 0;
    overflow-y: initial;
  }
`;

export const Body = styled.main`
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const ImageWeb = styled.img`
  @media (max-width: 768px){
    display: none;
  }
`

export const ImageMobile = styled.img`
  @media (min-width: 769px){
    display: none;
  }
`


export const SideBanner = styled.div`
  width: 100%;
  max-width: 425.14px;
  height: 100%;
  ${({ theme }) =>
    css`
      background-image: linear-gradient(209deg, ${theme.colors.lightBlue}, ${theme.colors.purple});
    `
  }

  padding: 49px 0px 0px 60px;

  svg {
    color: white;
    margin-bottom: 88.69px;
    height: 36.31px;
    width: 173.42px;
    path, .a {
      color: white;
      fill: white !important;
    }
  }


  img {
    margin-bottom: 88.69px;
    color: white;
    @media (max-width: 768px) {
      margin-bottom: 15px;
    }
  }


  @media (max-width: 769px) {
    padding: 25px 22.21px 15px 25px;
    max-width: 100%;

    svg {
      margin-bottom: 0px;
    }
  }

`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  span {

    font-size: 0.75rem;
    color: #5E5E5E;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};

    display: flex;
    align-items: center;

  }

  h1 {

    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};

  }

  h2 {

    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
	  line-height: 30px;
	  font-weight: 400px;

  }

  p {

	  color: ${({ theme }) => theme.colors.black};
	  font-weight: bold;

  }

  @media (max-width: 768px) {

    position: absolute;
    top: 0;
    left: 0;
    margin: 81px 22.21px 15px 25px;

    svg {
      color: white;
      font-size: 0.75rem;
    }

    span {
      color: white;
      font-size: 0.75rem;
    }

    h1 {
      color: white;
      font-size: 1.125rem;
	    line-height: normal;
    }

    h2 {
      color: #C9DFFF;
      font-size: 0.8125rem;
	    line-height: normal;
    }

  }

`;
export const Section = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 370px;

    margin-top: 243px;

    @media (max-width: 768px) {
        margin-top: 0;
        place-self: center;
    }
    
`;


export const SuccessContainer = styled.div`
    color: #0ECB00;
    margin-top: 38px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;

    display: grid;
    grid-template-columns: auto auto;
    justify-content: center;
    place-items: center;
    svg {
      margin-bottom: 23px;
      ${({errorState, theme}) => errorState && css`
        color: ${theme.colors.red};
      `}
    }

    p {
        color: #4D565C;
        font-size: 1.125rem;
        margin-left: 13px;
    }

    @media (max-width: 768px) {
        grid-template-columns: auto;
        height: auto;
        width: 210px;
        border: none;
        margin-top: 0;
        margin-bottom: 40px;
        text-align: center;
        svg {
            font-size: 46px;
        }
    }
    
    
`;


export const ButtonContainer = styled.div`
    margin-top: 57.5px;
    max-width: 389.91px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;

    a {
        text-decoration: none;
    }
    
    button {
        width: 100%;
    }

    @media (max-width: 768px) {
        margin-top: 0;
    }

`;


export const Header = styled.header`
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        position: absolute;
        top: 0;
        left: 0;
        margin: 81px 22.21px 15px 25px;
        color: white;

        span {
            color: white;
            font-size: 0.75rem;
            display: flex;
            align-items: center;
        }

        h1 {
            color: white;
            font-size: 1.125rem;
            line-height: normal;
        }

        h2 {
            color: #C9DFFF;
            font-size: 0.8125rem;
            line-height: normal;
        }
    }
`;